/* eslint-disable import/prefer-default-export */
import imagePending from 'src/assets/images/mobile-pending.png';
import imageVerified from 'src/assets/images/mobile-verified.png';
import imageUserSetup from 'src/assets/images/mobile-user-setup.png';

const finalScreenData = [
  {
    status: "pending",
    title: "KYC Verification Pending",
    subTitle: "Submission successful, Verification within 24-72 hrs",
    icon: imagePending,
    steps: ["e_sign_completed", "verification_pending", "verified"],
    stepsText: [
      {
        title: "Submitted",
        description: "Your onboarding application has been submitted.",
      },
      {
        title: "Verification",
        description: "Please wait for 2-3 business days until the Exchange verifies your details.",
      },
      {
        title: "Account Setup",
        description: "Login details will be sent to your registered email ID.",
      },
    ],
  },
  {
    status: "approved",
    title: "Application Approved",
    subTitle: "Verification complete, Welcome email sent",
    icon: imageVerified,
    steps: ["user_setup"],
    stepsText: [
      {
        title: "Submitted",
        description: "Your onboarding application has been submitted.",
      },
      {
        title: "Verified",
        description: "Your KYC details have been verified.",
      },
      {
        title: "Account Setup",
        description: "Login details have been sent to your registered email ID.",
      },
    ],
  },
  {
    status: "setupComplete",
    title: "Onboarding Complete",
    subTitle: "TIQS account set up successfully",
    icon: imageUserSetup,
    steps: ["completed"],
    stepsText: [
      {
        title: "Submitted",
        description: "Your onboarding application has been submitted.",
      },
      {
        title: "Verified",
        description: "Your KYC details have been verified.",
      },
      {
        title: "Onboarded",
        description: "Congrats! You are a TIQS trader now.",
      },
    ],
  },
]

export { finalScreenData }
